import { render, staticRenderFns } from "./authError.vue?vue&type=template&id=37aea460&scoped=true&"
import script from "./authError.vue?vue&type=script&lang=js&"
export * from "./authError.vue?vue&type=script&lang=js&"
import style0 from "./authError.vue?vue&type=style&index=0&id=37aea460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aea460",
  null
  
)

export default component.exports